import locale from 'date-fns/locale/nn';
export default locale;
